module.exports = __webpack_public_path__ + "static/media/books-medical.c4c560e5.svg";